(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["life-report-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.lrReady)return;window.lrReady=1;
  var T=[
    {w:'Basic ',t:'Your life, your numbers, your path.',c:'Get your Basic report',n:4,l:'Level 1 of 3: Foundation',b:33,d:'Understand the core numbers hidden in your name and birth date.'},
    {w:'Advanced ',t:'Know yourself. Plan your future.',c:'Get your Advanced report',n:7,l:'Level 2 of 3: Deeper',b:66,d:'See how your numbers shape money, health and the years ahead.'},
    {w:'Golden ',t:'Numerology and astrology, together.',c:'Get your Golden report',n:8,l:'Level 3 of 3: Deepest',b:100,d:'Read your numbers together with your stars for the complete picture.'}
  ];
  var LV=[0,0,0,0,1,1,1,2],NM=['','In Advanced','In Golden'];
  function refs(root){
    var q=function(s){return root.querySelector(s)},li=root.querySelectorAll('.lr-li'),rows=[];
    for(var k=0;k<li.length;k++)rows.push({li:li[k],ic:li[k].firstChild,em:li[k].lastChild});
    return root._lr={wrap:q('.lr-wrap'),h:q('.lr-h'),tag:q('.lr-tag'),n:q('.lr-n'),dl:q('.lr-dl'),bf:q('.lr-bf'),dt:q('.lr-dt'),cta:q('.lr-cta'),rows:rows};
  }
  document.addEventListener('change',function(e){
    var r=e.target;
    if(!r.classList||!r.classList.contains('lr-in'))return;
    var root=r.closest('.lr'),i=+r.value,t=T[i],o=root._lr||refs(root);
    o.wrap.setAttribute('data-tier',i);
    o.h.firstChild.nodeValue=t.w;
    o.tag.textContent=t.t;
    o.n.textContent=t.n;
    o.dl.textContent=t.l;
    o.bf.style.width=t.b+'%';
    o.dt.textContent=t.d;
    o.cta.textContent=t.c;
    o.cta.setAttribute('href',o.wrap.getAttribute('data-cta'+i)||'#');
    for(var k=0;k<o.rows.length;k++){
      var w=o.rows[k],on=LV[k]<=i;
      w.li.classList.toggle('lr-off',!on);
      w.ic.textContent=on?'\u2713':'+';
      w.em.textContent=on?'':NM[LV[k]];
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.scCarouselLoaded) return;
  window.scCarouselLoaded = true;

  var list = [], timer;

  function create(root) {
    if (root.getAttribute('data-sc-init')) return;
    root.setAttribute('data-sc-init', '1');

    var vp = root.querySelector('.sc-vp'),
        rail = root.querySelector('.sc-rail'),
        dotsEl = root.querySelector('.sc-dots');
    if (!vp || !rail || !dotsEl) return;

    var all = [].slice.call(rail.children), cur = [], i = 0, started = false;

    function vis() {
      var w = window.innerWidth, c = parseFloat(root.dataset.cards) || 5;
      return w <= 760 ? (parseFloat(root.dataset.cardsMobile) || 2) : (w <= 1100 ? Math.min(4, c) : c);
    }
    function step() {
      var a = cur[0], b = cur[1];
      return b ? b.offsetLeft - a.offsetLeft : (a ? a.offsetWidth : 0);
    }
    function maxI() { return Math.max(0, Math.ceil(cur.length - vis())); }

    function render() {
      var v = vis();
      rail.style.setProperty('--v', v);
      rail.style.transform = 'translateX(' + (-i * step()) + 'px)';
      cur.forEach(function (c, n) {
        var o = (n >= i && n < i + v) ? 1 : .35;
        if (c._o !== o) { c._o = o; c.style.setProperty('--o', o); }
      });
      [].forEach.call(dotsEl.children, function (d, n) { d.classList.toggle('on', n === i); });
    }

    function buildDots() {
      dotsEl.innerHTML = '';
      var m = maxI();
      if (!m) return;
      var frag = document.createDocumentFragment();
      for (var n = 0; n <= m; n++) {
        (function (n) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'sc-dot';
          d.setAttribute('aria-label', 'Go to slide ' + (n + 1));
          d.onclick = function () { go(n); };
          frag.appendChild(d);
        })(n);
      }
      dotsEl.appendChild(frag);
    }

    /* agle slide ki images pehle se mangwa lo, taaki slide karne par khali na dikhe */
    function warm() {
      var end = Math.min(cur.length, i + Math.ceil(vis()) * 2);
      for (var n = i; n < end; n++) {
        var im = cur[n].querySelector('img');
        if (im && im.loading === 'lazy') im.loading = 'eager';
      }
    }

    function go(n) {
      var m = maxI();
      i = n > m ? 0 : (n < 0 ? m : n);
      render();
      warm();
    }

    function show(t) {
      all.forEach(function (c) {
        c.hidden = !(t === '__all' || c.dataset.cat === t);
      });
      cur = all.filter(function (c) { return !c.hidden; });
      i = 0;
      rail.classList.add('snap');
      render();
      void rail.offsetWidth;
      rail.classList.remove('snap');
      buildDots();
      render();
    }

    function start() {
      if (started) return;
      started = true;

      root.addEventListener('click', function (e) {
        var t = e.target.closest('.sc-tab');
        if (t) {
          var on = root.querySelector('.sc-tab.on');
          if (on) on.classList.remove('on');
          t.classList.add('on');
          show(t.dataset.t);
          return;
        }
        var a = e.target.closest('.sc-ar');
        if (a) go(a.classList.contains('l') ? i - 1 : i + 1);
      });

      var sx = null, dx = 0, moved = false;
      vp.addEventListener('pointerdown', function (e) { sx = e.clientX; dx = 0; moved = false; });
      vp.addEventListener('pointermove', function (e) {
        if (sx === null) return;
        dx = e.clientX - sx;
        if (Math.abs(dx) > 6) { moved = true; vp.classList.add('drag'); }
      });
      function end() {
        if (sx === null) return;
        if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
        sx = null;
        vp.classList.remove('drag');
      }
      vp.addEventListener('pointerup', end);
      vp.addEventListener('pointercancel', end);
      vp.addEventListener('pointerleave', end);
      vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);

      show('__all');
    }

    list.push({
      root: root,
      resize: function () {
        if (!started) return;
        if (i > maxI()) i = maxI();
        buildDots();
        render();
      }
    });

    if ('IntersectionObserver' in window) {
      var lazy = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { lazy.disconnect(); start(); }
      }, { rootMargin: '200px 0px' });
      lazy.observe(root);
    } else {
      start();
    }
  }

  function scan(scope) {
    [].forEach.call((scope || document).querySelectorAll('.sc[data-cards]'), create);
  }

  /* ek hi resize listener sab carousels ke liye */
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      list = list.filter(function (x) { return x.root.isConnected; });
      list.forEach(function (x) { x.resize(); });
    }, 120);
  });

  /* theme editor mein section reload ho to dobara chalu */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();

  } catch(e) { console.error(e); }
})();
})();
